// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import OutfitProduct from '@tcp/core/src/components/features/browse/OutfitDetails/molecules/OutfitProduct/OutfitProduct';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/BundleProductItems.style';
import { checkInWishlistUtil } from '../../../../ProductListing/molecules/ProductList/utils/productsCommonUtils';

class BundleProductItems extends React.PureComponent {
  /**
   * @function renderItem populates the L1 menu item from the data passed to it
   * @param {object} item Details of the L1 menu item passed from the loop
   */

  renderItems = () => {
    const {
      currentBundle,
      addToBagEcom,
      addToFavorites,
      currentState,
      addToBagError,
      addToBagErrorId,
      handleAddToBag,
      isLoggedIn,
      currencySymbol,
      currencyAttributes,
      className,
      isKeepAliveEnabled,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      isOnModelAbTestBundlePdp,
      isInternationalShipping,
      isEnabledOutfitAddedCTA,
      showAddedToBagCta,
      wishList,
      onSetLastDeletedItemIdAction,
      isOutfitPage,
      errorMessages,
      alternateBrand,
      isHideOriginalPriceAndMarchantTagEnabled,
      isBundleOutfitInfluencerHandleEnabled,
      isSplittingExtendedSizesEnabled,
    } = this.props;

    return (
      <ul className="outfiting-list-container">
        {currentBundle &&
          currentBundle.map((product) => {
            const influencerTags = product?.products?.colorFitsSizesMap?.[0]?.influencerTags;
            const productItem = product && product.products;
            const primaryBrand = (productItem && productItem.primaryBrand) || alternateBrand;
            return productItem ? (
              <li key={product.generalProductId} className="bundle-product-item">
                <OutfitProduct
                  outfitProduct={productItem}
                  productIndexText=""
                  handleAddToBag={() => {
                    handleAddToBag(
                      addToBagEcom,
                      productItem,
                      productItem?.generalProductId,
                      currentState,
                      primaryBrand
                    );
                  }}
                  className={`${className} outfiting-list-details`}
                  addToBagError={addToBagErrorId === productItem?.productId && addToBagError}
                  isLoggedIn={isLoggedIn}
                  addToFavorites={addToFavorites}
                  currencySymbol={currencySymbol}
                  currencyAttributes={currencyAttributes}
                  isBundleProduct
                  isKeepAliveEnabled={isKeepAliveEnabled}
                  AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
                  removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
                  pageName="BUNDLE"
                  isOnModelAbTestBundlePdp={isOnModelAbTestBundlePdp}
                  isInternationalShipping={isInternationalShipping}
                  showAddedToBagCta={
                    isEnabledOutfitAddedCTA && showAddedToBagCta === productItem?.productId
                  }
                  isInWishList={checkInWishlistUtil(wishList, productItem?.productId)}
                  onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
                  wishList={wishList}
                  isOutfitPage={isOutfitPage}
                  errorMessages={errorMessages}
                  alternateBrand={alternateBrand}
                  primaryBrand={primaryBrand}
                  isHideOriginalPriceAndMarchantTagEnabled={
                    isHideOriginalPriceAndMarchantTagEnabled
                  }
                  influencerTags={influencerTags}
                  isBundleOutfitInfluencerHandleEnabled={isBundleOutfitInfluencerHandleEnabled}
                  isSplittingExtendedSizesEnabled={isSplittingExtendedSizesEnabled}
                />
              </li>
            ) : null;
          })}
      </ul>
    );
  };

  render() {
    return <div className="bundle-productsList-container">{this.renderItems()}</div>;
  }
}

BundleProductItems.propTypes = {
  currentBundle: PropTypes.shape({}),
  addToBagEcom: PropTypes.func.isRequired,
  handleAddToBag: PropTypes.func.isRequired,
  currentState: PropTypes.shape({}).isRequired,
  addToBagError: PropTypes.string,
  addToBagErrorId: PropTypes.string,
  addToFavorites: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
  currencyAttributes: PropTypes.shape({}).isRequired,
  currencySymbol: PropTypes.string,
  className: PropTypes.string,
  isKeepAliveEnabled: PropTypes.bool.isRequired,
  AddToFavoriteErrorMsg: PropTypes.string,
  removeAddToFavoritesErrorMsg: PropTypes.func,
  isOnModelAbTestBundlePdp: PropTypes.bool,
  isInternationalShipping: PropTypes.bool.isRequired,
  isEnabledOutfitAddedCTA: PropTypes.bool,
  showAddedToBagCta: PropTypes.string,
  wishList: PropTypes.func.isRequired,
  onSetLastDeletedItemIdAction: PropTypes.func,
  isOutfitPage: PropTypes.bool,
  errorMessages: PropTypes.shape({}),
};

BundleProductItems.defaultProps = {
  currentBundle: null,

  addToBagError: '',
  addToBagErrorId: '',
  isLoggedIn: false,
  currencySymbol: 'USD',
  className: '',
  AddToFavoriteErrorMsg: '',
  removeAddToFavoritesErrorMsg: () => {},
  isOnModelAbTestBundlePdp: false,
  isEnabledOutfitAddedCTA: false,
  showAddedToBagCta: '',
  onSetLastDeletedItemIdAction: () => {},
  isOutfitPage: false,
  errorMessages: {},
};
export default withStyles(BundleProductItems, styles);
export { BundleProductItems as BundleProductItemsVanilla };
